import { AiRecommendationCard } from "./ai-recommendation-card";

import "./ai-recommendation-section.scss";

export const AiRecommendationSection = ({ items, onRemove, onRestore }) => (
  <section className="ai-recommendation-section">
    <div className="ai-recommendation-section__items">
      {items.map((item) => (
        <AiRecommendationCard
          key={item.id}
          item={item}
          onRemove={onRemove}
          onRestore={onRestore}
        />
      ))}
    </div>
  </section>
);
